// import React, { useState } from "react";
// import { Tooltip as ReactTooltip } from "react-tooltip";
// import { MdArrowForwardIos } from "react-icons/md";
// import { FaCircle } from "react-icons/fa";


// function Action() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [isBulkEditOpen, setIsBulkEditOpen] = useState(false);

//   const toggleDropdown = () => {
//     setIsOpen((prev) => !prev);
//   };

//   const statusPopStyle =
//     "px-4 py-2 hover:bg-gray-100 cursor-pointer items-center flex justify-center gap-2 group";

//   return (
//     <div className="relative inline-block text-left">
//       <div className="group relative cursor-pointer">
//         <div
//           data-tooltip-id="main-tooltip"
//           data-tooltip-content="Action"
//           onClick={toggleDropdown}
//           className="text-sm bg-gray-200 text-gray-500 shadow-sm
//             font-semibold rounded-md px-4 py-1.5 flex gap-2
//             items-center justify-center text-center border
//             border-transparent
//             hover:text-gray-800 transition-all"
//         >
//           Action
//         </div>
//       </div>

//       {isOpen && (
//         <div
//           className="absolute z-50 mt-2 border w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"
//           onMouseLeave={() => setIsOpen(false)}
//         >
         
//           <div className="py-1 text-sm text-gray-700">
//             <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer" onClick={() => setIsBulkEditOpen(true)}
// >
//               Bulk Edit
//             </div>
//             <div className="group relative">
//               <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center justify-start">
//                 <MdArrowForwardIos className="group-hover:rotate-180 transition-all" />
//                 Status{" "}
//               </div>
//               {/* Submenu (can be enhanced later) */}
//               <div className="absolute right-full border top-0 mt-0 mr-1 w-36 text-center rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 hidden group-hover:block">
//                 <div className="py-1 text-sm text-gray-700">
//                   <div className={statusPopStyle}>
//                     <FaCircle
//                       color="green"
//                       className=" hidden group-hover:block"
//                       size={8}
//                     />
//                     Activate
//                   </div>
//                   <div className={statusPopStyle}>
//                     <FaCircle
//                       color="Black"
//                       className=" hidden group-hover:block"
//                       size={8}
//                     />
//                     Deactivate
//                   </div>
//                   <div className={statusPopStyle}>
//                     <FaCircle
//                       color="Pink"
//                       className=" hidden group-hover:block"
//                       size={8}
//                     />
//                     Passive
//                   </div>
//                   <div className={statusPopStyle}>
//                     <FaCircle
//                       color="Yellow"
//                       className=" hidden group-hover:block"
//                       size={8}
//                     />
//                     On Hold
//                   </div>
//                   <div className={statusPopStyle}>
//                     <FaCircle
//                       color="blue"
//                       className=" hidden group-hover:block"
//                       size={8}
//                     />
//                     Premium
//                   </div>
//                   <div className={statusPopStyle}>
//                     <FaCircle
//                       color="red"
//                       className="hidden group-hover:block"
//                       size={8}
//                     />
//                     Suspended
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
//               Export selected
//             </div>
//             <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
//               Assigned to
//             </div>
//             <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
//               Add tags
//             </div>
//             <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
//               Email to Selected Contacts
//             </div>
//             <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
//               SMS to Selected Contacts
//             </div>
//             <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
//               What's App Message to Selected Contacts
//             </div>
//             <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
//               Delete
//             </div>
//           </div>
//         </div>
//       )}

//       <ReactTooltip
//         id="main-tooltip"
//         place="top"
//         effect="solid"
//         className="!text-[14px] !rounded-md !px-5 !py-[2px] !text-white z-20 shadow-md"
//       />
//         {/* <BulkEdit isOpen={isBulkEditOpen} onClose={() => setIsBulkEditOpen(false)} />  */}
//     </div>

//   );
// }

// export default Action;

import React, { useState, useEffect } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { MdArrowForwardIos } from "react-icons/md";
import { FaCircle } from "react-icons/fa";
import SuccessPopup from "./Modals/Popup/SuccessPopup";
import ExportModalPopup from "./Modals/Popup/ExportModalPopup";
import AssignedToPopup from "./Modals/Popup/AssignedToPopup";
import AddTagPopup from "./Modals/Popup/AddTagPopup";
import DeletePopup from "./Modals/Popup/DeletePopup";
import { useNavigate } from "react-router-dom";
import ExportSuccessPopup from "./Modals/Popup/ExportSuccessPopup";
import AssignSuccessPopup from "./Modals/Popup/AssignSuccessPopup";
import AddTagSuccessPopup from "./Modals/Popup/AddTagSuccessPopup";
import DeleteSuccessPopup from "./Modals/Popup/DeleteSuccessPopup";


function Action({ onClose }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isBulkEditOpen, setIsBulkEditOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedField, setSelectedField] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
const [showExportModal, setShowExportModal] = useState(false);
 const [showAssignedToModal, setShowAssignedToModal] = useState(false);
 const [showAddTags, setShowAddTags] = useState(false);
 const [showDelete, setShowDelete]  = useState(false);
 const [showExportSuccessPopup, setShowExportSuccessPopup]  = useState(false);
 const [showAssignedSuccessPopup, setShowAssignedSuccessPopup] = useState(false);
 const[showAddTagSuccessPopup, setShowAddTagSuccessPopup] = useState(false);
 const[showDeleteSuccessPopup , setShowDeleteSuccessPopup] = useState(false)
 const navigate = useNavigate();

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const statusPopStyle =
    "px-4 py-2 hover:bg-gray-100 cursor-pointer items-center flex justify-center gap-2 group";

    
  const groupedFields = [
    {
      group: "Product Details",
      items: [
        "Product Name",
        "Categories of Product",
        "HSN Code of Products",
        "Required Quantity of Product",
        "Indicative Price Range",
      ],
    },
    {
      group: "Other Fields",
      items: ["Status"],
    },
    {
      group: "Executives",
      items: [
        "Company ID",
        "Company Name",
        "Company Website URL",
        "Nature Of Business",
        "Primary Email ID",
        "Additional Email ID",
        "Primary Contact Number",
        "Additional Contact Number",
        "Company Linedin URL",
      ],
    },
    {
      group: "Executives",
      items: ["Country", "City/ District", "Locality", "Street", "Pin Code"],
    },
    {
      group: "Other Business Details",
      items: [
        "Tax ID",
        "Preferred Currency",
        "Type Of Company",
        "Year Of Incorporation",
        "Yearly Revenue",
        "Number Of Employees",
      ],
    },
  ];

  const handleFieldSelect = (item) => {
    setSelectedField(item);
    setDropdownOpen(false);
  };

  useEffect(() => {
    if (showSuccess) {
      const timer = setTimeout(() => setShowSuccess(false), 6000);
      return () => clearTimeout(timer);
    }
  }, [showSuccess]);

  return (
    <div className="relative inline-block text-left">
      {/* Action Button */}
      <div className="group relative cursor-pointer">
        <div
          data-tooltip-id="main-tooltip"
          data-tooltip-content="Action"
          onClick={toggleDropdown}
          className="text-sm bg-gray-200 text-gray-500 shadow-sm font-semibold rounded-md px-4 py-1.5 flex gap-2 items-center justify-center text-center border border-transparent hover:text-gray-800 transition-all"
        >
          Action
        </div>
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div
          className="absolute z-50 mt-2 border w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5"
          onMouseLeave={() => setIsOpen(false)}
        >
          <div className="py-1 text-sm text-gray-700">
            <div
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                setIsBulkEditOpen(true);
                setIsOpen(false);
              }}
            >
              Bulk Edit
            </div>

            {/* Status Submenu */}
            <div className="group relative">
              <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center justify-start">
                <MdArrowForwardIos className="group-hover:rotate-180 transition-all" />
                Status
              </div>
              <div className="absolute right-full border top-0 mt-0 mr-1 w-36 text-center rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 hidden group-hover:block">
                <div className="py-1 text-sm text-gray-700">
                  {["Activate", "Deactivate", "Passive", "On Hold", "Premium", "Suspended"].map(
                    (status, index) => (
                      <div key={index} className={statusPopStyle}>
                        <FaCircle
                          color={["green", "black", "pink", "yellow", "blue", "red"][index]}
                          className="hidden group-hover:block"
                          size={8}
                        />
                        {status}
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>

            {/* Other Actions */}
            {[
              "Export selected",
              "Assigned to",
              "Add tags",
              "Email to Selected Contacts",
              "SMS to Selected Contacts",
              "What's App Message to Selected Contacts",
              "Delete",
            ].map((label, i) => (
             <div
    key={i}
    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
    onClick={() => {
      if (label === "Export selected") {
        setShowExportModal(true); 
        setIsOpen(false); 
      }
     else if (label === "Assigned to") { 
                    setShowAssignedToModal(true); 
                    setIsOpen(false); 
                  }
                  else if (label === "Add tags") { 
                    setShowAddTags(true); 
                    setIsOpen(false); 
                  }  else if (label === "Delete") { 
              setShowDelete(true); 
                    setIsOpen(false); 
                  } else if (label === "Email to Selected Contacts") {
    setIsOpen(false);
    navigate("/admin-dashboard/view-osp");
  }
  else if (label === "SMS to Selected Contacts") {
    setIsOpen(false);
    navigate("/admin-dashboard/view-osp");
  }
   else if (label === "What's App Message to Selected Contacts") {
    setIsOpen(false);
    navigate("/admin-dashboard/view-osp");
  }
    }}
  >
    {label}
  </div>
            ))}
          </div>
        </div>
      )}

      {/* Tooltip */}
      <ReactTooltip
        id="main-tooltip"
        place="top"
        effect="solid"
        className="!text-[14px] !rounded-md !px-5 !py-[2px] !text-white z-20 shadow-md"
      />

      {/* Bulk Edit Popup */}
      {isBulkEditOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg w-[500px] shadow-lg relative">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold text-gray-800">Bulk Edit</h2>
              <button
                onClick={() => {
                  setIsBulkEditOpen(false);
                  setSelectedField("");
                }}
                className="text-gray-600 text-xl"
              >
                ×
              </button>
            </div>
            <p className="text-sm text-gray-500 mb-4">
              You can able to edit only one field at a time
            </p>

            {/* Custom Field Dropdown */}
            <div className="mb-6 relative">
              <label className="block text-sm font-normal mb-1">
                Fields <span className="text-red-500">*</span>
              </label>
              <div
                className="border w-[50%] rounded px-3 py-2 cursor-pointer flex justify-between items-center bg-green-100"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                <span className={selectedField ? "text-black" : "text-gray-400"}>
                  {selectedField || "Select a field"}
                </span>
                <span className="text-gray-500 ml-4">&#9662;</span>
              </div>

              {dropdownOpen && (
                <div className="absolute z-10 mt-1 w-[50%] bg-white border border-gray-300 rounded shadow max-h-60 overflow-auto">
                  {groupedFields.map((group, idx) => (
                    <div key={idx} className="p-2">
                      <p className="text-gray-700 font-semibold underline mb-1">{group.group} :</p>
                      {group.items.map((item, i) => (
                        <div
                          key={i}
                          className="px-3 py-1 hover:bg-gray-100 cursor-pointer text-sm text-gray-800"
                          onClick={() => handleFieldSelect(item)}
                        >
                          {item}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              )}
              <p className="text-xs text-red-500 mt-1">This field is not for bulk edit</p>
            </div>

            {/* Value input */}
            <div className="mb-6">
              <label className="block text-sm font-normal mb-1">
                Values <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Select values"
                className="w-[50%] p-2 border bg-green-100 rounded-md focus:outline-none text-black"
              />
            </div>

            {/* Update Button */}
            <div className="text-right">
              <button
                className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700"
                onClick={() => {
                  setIsBulkEditOpen(false);
                  setShowSuccess(true);
                }}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}

     {showSuccess && <SuccessPopup onClose={() => setShowSuccess(false)} />}
        {showExportModal && (
  <ExportModalPopup isOpen={showExportModal} onClose={() => {setShowExportModal(false); setShowExportSuccessPopup(true)}}   />)}

 {showExportSuccessPopup && ( <ExportSuccessPopup isOpen={showExportSuccessPopup} onClose={()=>setShowExportSuccessPopup(false)} /> )}
  


   {showAssignedToModal && (
  <AssignedToPopup isOpen={showAssignedToModal} onClose={() => {setShowAssignedToModal(false); setShowAssignedSuccessPopup(true)}} />)}
 {showAssignedSuccessPopup && ( <AssignSuccessPopup isOpen={showAssignedSuccessPopup} onClose={()=>setShowAssignedSuccessPopup(false)} /> )}

  {showAddTags && (
  <AddTagPopup isOpen={showAddTags} onClose={() => {setShowAddTags(false); setShowAddTagSuccessPopup(true)}}/>)}
   {showAddTagSuccessPopup && ( <AddTagSuccessPopup isOpen={showAddTagSuccessPopup} onClose={()=>setShowAddTagSuccessPopup(false)} /> )}

{showDelete && (
  <DeletePopup isOpen={showDelete} onClose={() => {setShowDelete(false); setShowDeleteSuccessPopup(true)}} />)}
    {showDeleteSuccessPopup && ( <DeleteSuccessPopup isOpen={showDeleteSuccessPopup} onClose={()=>setShowDeleteSuccessPopup(false)} /> )}

    </div>
  );
}

export default Action;
